import { DocumentSkeleton } from './DocumentSkeleton';
import { PreviewSectionSkeleton } from './SectionSkeleton';

export const StorePreviewSkeleton = () => {
  return (
    <div className="w-full flex flex-col gap-6">
      {/* CLUB INFO */}
      <PreviewSectionSkeleton rows={9} />

      {/* BUSINESS INFO */}
      <div className="flex flex-col gap-3">
        <PreviewSectionSkeleton rows={3} />

        <DocumentSkeleton />
        <DocumentSkeleton />

        <div className="flex flex-col gap-2">
          <DocumentSkeleton />
          <DocumentSkeleton />
        </div>
      </div>

      {/* USER INFO */}
      <PreviewSectionSkeleton rows={3} />
    </div>
  );
};
